import type { FileType } from './extractStudents';

export type FileWithCount = {
  id: string;
  type?: FileType;
  studentCount?: number;
};

export function applyStudentCountIfTypeMatches<F extends FileWithCount>(
  files: F[],
  id: string,
  parsedType: FileType,
  count: number
): F[] {
  return files.map((f) =>
    f.id === id && f.type === parsedType ? { ...f, studentCount: count } : f
  );
}
